import { render, staticRenderFns } from "./interface-authorize.vue?vue&type=template&id=6eeefc14&scoped=true"
import script from "./interface-authorize.vue?vue&type=script&lang=js"
export * from "./interface-authorize.vue?vue&type=script&lang=js"
import style0 from "./interface-authorize.vue?vue&type=style&index=0&id=6eeefc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeefc14",
  null
  
)

export default component.exports